// extracted by mini-css-extract-plugin
export default {"caret":"---------packages-corgi-x-src-components-Breadcrumbs-Breadcrumbs-module__caret","root":"---------packages-corgi-x-src-components-Breadcrumbs-Breadcrumbs-module__root"};